import { render, staticRenderFns } from "./SQuesTwelve.vue?vue&type=template&id=66ab1a57&scoped=true&"
import script from "./SQuesTwelve.vue?vue&type=script&lang=js&"
export * from "./SQuesTwelve.vue?vue&type=script&lang=js&"
import style0 from "./SQuesTwelve.vue?vue&type=style&index=0&id=66ab1a57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ab1a57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
